import { createContext } from 'react';

const StepsFormContext: React.Context<StepsFormContextValues> =
  createContext<StepsFormContextValues>({} as StepsFormContextValues);

export default StepsFormContext;
